<style lang="scss" scoped>
.slider-item {
  display: flex;
  .comp-picker-link {
    flex: 1;
  }
}
</style>
<template>
  <CompButton
    placeholder="选择商品"
    format="{0}个商品"
    :viewBtn="multiple"
    :disabled="disabledBtn"
    :value="value.length"
    @click="handleClickAdd"
    @remove="onRemove"
    @view="onViewItem"
  />
</template>

<script>
import { cloneDeep } from 'lodash'
import CompButton from '../../comps/comp-button'
export default {
  name: 'AttrGoods',
  components: { CompButton },
  props: ['value', 'distributor', 'multiple', 'disabled'],
  data() {
    return {
      localValue: []
    }
  },
  computed: {
    disabledBtn() {
      const { id } = this.distributor
      return id === '' || this.disabled
    }
  },
  watch: {
    localValue: function (nVal, oVal) {
      this.$emit('input', nVal)
    },
    distributor: function (nVal, oVal) {
      if (JSON.stringify(nVal) != JSON.stringify(oVal)) {
        this.localValue = []
      }
    }
  },
  updated() {
    // this.localValue = cloneDeep(this.value)
  },
  methods: {
    async handleClickAdd() {
      const ids = this.value.map(({ goodsId }) => goodsId)
      console.log('🚀 ~ file: attr-goods.vue:56 ~ this.value:', this.value)
      const { data } = await this.$picker.goods({
        data: ids,
        queryParams: {
          distributor_id: this.distributor.id
        },
        paramsFieldExclude: ['distributor_id'],
        multiple: this.multiple === false ? false : true
      })
      this.localValue = data.map((item) => {
        const { item_id, pics, price, item_name } = item
        return {
          ...item,
          goodsId: item_id,
          title: item_name,
          imgUrl: pics?.[0],
          price
        }
      })
    },
    onRemove() {
      this.localValue = []
    },
    async onViewItem() {
      this.localValue = cloneDeep(this.value)
      const { localValue, value } = this
      const { data } = await this.$picker.editBoard({
        data: localValue,
        template: ({ imgUrl }) => {
          return <SpImage src={imgUrl} width={100} height={100} />
        },
        onAdd: async () => {
          const { data } = await this.$picker.goods({
            data: localValue.map(({ goodsId }) => goodsId),
            queryParams: {
              distributor_id: this.distributor.id
            },
            paramsFieldExclude: ['distributor_id'],
            multiple: this.multiple === false ? false : true
          })
          const res = data.map(({ item_id, pics, price, item_name }) => {
            return {
              goodsId: item_id,
              title: item_name,
              imgUrl: pics?.[0],
              price
            }
          })
          return res
        }
      })
      this.localValue = data
    }
  }
}
</script>
